import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PropertyDetailPage } from './pages/PropertyDetailPage';
import { CookieConsent } from './components/CookieConsent';
import { initializeAnalytics } from './hooks/useAnalytics';
export function App() {
  useEffect(() => {
    // Initialize analytics if user has already consented
    const hasConsent = localStorage.getItem('analytics_consent') === 'true';
    if (hasConsent) {
      initializeAnalytics();
    }
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/property/:id" element={<PropertyDetailPage data-id="element-5" />} data-id="element-4" />
      </Routes>
      <CookieConsent data-id="element-6" />
    </BrowserRouter>;
}